module.exports = __webpack_public_path__ + "img/warning-gray.3f7fca09.svg";